document.addEventListener('alpine:init', () => {
    window.Alpine.store('modalStore', {
        openModal: false,
        currentModalName: '',
        wizardModalStatus: false,
        recommendationModalStatus: false,
        closeBackdrop: true,
    });
    let formElement = document.querySelector('form[data-resetformaftersubmit]');
    window.Alpine.data('modal', () => ({
        closeModal: {
            ['@click'](){
                let oldModalName = this.$store.modalStore.currentModalName;
                // Close modal by it`s name
                this.$store.modalStore.currentModalName = null;
                // Set openModal to false and remove CSS class "overflow-hidden" from <body> tag
                this.$store.modalStore.openModal = false;

                this.removeParams(oldModalName);
                this.$store.modalStore;
                if (formElement) {
                    resetModalStore();
                }
            },
        },
        backdrop: {
            ['@click'](e) {
                if(this.$store.modalStore.closeBackdrop && e.target === e.currentTarget) {
                    let oldModalName = this.$store.modalStore.currentModalName;

                    this.$store.modalStore.openModal = false;
                    this.$store.modalStore.currentModalName = null;
                    this.removeParams(oldModalName);
                    if (formElement) {
                        resetModalStore();
                    }
                }
            },
        },
        removeParams(oldModalName) {
            if (oldModalName === 'eventRegistrationModal') {
                // remove all query parameter at close modal click
                let url = window.location.protocol + "//" + window.location.host + window.location.pathname;
                window.history.replaceState(url, document.title, url);
            }
        },

    }));
    window.resetModalStore = function () {
        Alpine.store('modalStore').currentModalName = 'SetupServiceModal';
        Alpine.store('modalStore').setupServiceModalStatus = true;
        //Reset forms if they exist [setupService | Google reCaptcha]
        document.forms["setupServices"]?.reset();
        typeof grecaptcha !== "undefined" && grecaptcha.reset();
        document.querySelectorAll('.bx-validate.is-valid').forEach((input) => {
            input.classList.remove('is-valid');
            input.classList.remove('is-focused');
        });
    };
});
